import { judges2021, legalAdvisor2021 } from './data';
import { Footer2021, Header2021, use2021Page } from './shared';

const Judges2021 = () => {
  const { lang } = use2021Page('Smart Living Partnership Awards 2021 - Judges');
  return (
    <>
      <Header2021 lang={lang} currentPath="judges" />
      <main>
        <div className="background-container" style={{ backgroundImage: 'url(/2021/images/judges.png)', marginTop: '8.1%' }}>
          <img src="/2021/images/judges.png" style={{ visibility: 'hidden' }} alt="" />
        </div>
        <div className="background-container" style={{ backgroundImage: 'url(/2021/images/judges2.png)' }}>
          <img className="judges-bottom" src="/2021/images/judges2.png" style={{ visibility: 'hidden' }} alt="" />
          <div className="background-info">
            <div className="judges-image-container">
              <h1 style={{ fontWeight: '400' }}><b>{lang === 'zh' ? '評審' : 'Judges'}</b></h1>
              <div style={{ display: 'flex', width: '100%' }}>
                <div style={{ width: '40%' }}><img src="/2021/images/judges/judge_head.jpg" alt="" /></div>
                <div className="judges-info-container">
                  <h1 style={{ color: '#fff' }}><b>{judges2021.head[lang].title}</b></h1>
                  <h2>{judges2021.head[lang].name}</h2>
                  <p style={{ whiteSpace: 'pre-line' , width: '80%'}}>{judges2021.head[lang].bio}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="background-container" style={{ backgroundImage: 'url(/2021/images/judges3.png)' }}>
          <img src="/2021/images/judges3.png" style={{ visibility: 'hidden' }} alt="" />
          <div className="background-info">
            <div className="judges-image-container">
              <h1><b>{lang === 'zh' ? '其他評審' : 'Other Judges'}</b></h1>
              <div className="judges-logo-container" style={{ width: '100%' }}>
                {judges2021.others.map((j) => (
                  <div className="member" key={j.key}>
                    <img style={{ marginTop: 2, boxShadow: '0 2px 8px #b2abb1', width: '80%' }} src={`/2021/images/judges/${j.key}.png`} alt="" />
                    <div className="member_text_container">
                      <div className="name" style={{ textAlign: 'center' }}><b>{lang === 'zh' ? j.zh : j.en}</b></div>
                      <div className="title" style={{ textAlign: 'center' }}>{lang === 'zh' ? j.bioZh : j.bioEn}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="background-container" style={{ backgroundImage: 'url(/2021/images/judges2.png)' }}>
          <img className="judges-bottom" src="/2021/images/judges2.png" style={{ visibility: 'hidden' }} alt="" />
          <div className="background-info">
            <div className="judges-image-container">
              <h1><b>{legalAdvisor2021[lang].title}</b></h1>
              <div className="judges-logo-container" style={{ width: '100%' }}>
                <div className="member">
                  <img style={{ marginTop: 2, boxShadow: '0 2px 8px #b2abb1', width: '80%' }} src="/2021/images/judges/legal_advisor.png" alt="" />
                  <div className="advisor_text_container">
                    <div className="name" style={{ textAlign: 'center' }}><b>{legalAdvisor2021[lang].name}</b></div>
                    <div className="title" style={{ textAlign: 'center' }}>{legalAdvisor2021[lang].bio}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer2021 lang={lang} />
    </>
  );
};

export default Judges2021;
